module.exports = __webpack_public_path__ + "img/ac4cca40ec4344ce8de99d56bd0fbee0-1440.d0735f63.jpg";